<div
  class="page-container"
  [style.margin-left]="layoutContentMarginLeft"
  [style.margin-right]="layoutContentMarginRight"
>
  <div class="main-container">
    <div class="container" [class.full-width]="fullWidth && !isH5">
      <div class="content-box" #contentBox>
        <!-- logo -->
        <app-logo
          *ngIf="isH5"
          [lockDevice]="logined ? 'h5' : 'web'"
          [onlineSize]="logined ? ['auto', '44'] : ['auto', '24']"
          [onlineSizeH5]="logined ? ['auto', '36'] : ['auto', '20']"
          [sitSize]="logined ? ['48', '44'] : ['116', '24']"
          [sitSizeH5]="logined ? ['38', '36'] : ['90', '20']"
          [clickable]="true"
        ></app-logo>

        <!-- WEB顶部菜单 -->
        <div class="menu-container" appLifeObserve #menuContainer *ngIf="!isH5">
          <app-logo
            class="animate__animated animate__faster animate__fadeIn animate__fill_none"
            *ngIf="!isH5 && logoShow"
            [lockDevice]="'web'"
            [onlineSize]="['auto', '24']"
            [onlineSizeH5]="['auto', '24']"
            [sitSize]="['116', '24']"
            [sitSizeH5]="['97', '24']"
            [clickable]="true"
          ></app-logo>
        </div>
        <div class="header-main" *ngIf="!isH5" appMouseScroll>
          @if (!headerLevel2Menu) {
            <ng-container *ngFor="let item of menuItems">
              <a *ngIf="isHeaderMenuReady" [href]="domain + item.routerLink" (click)="$event.preventDefault()">
                <div class="menu-item onact96" [routerLink]="item.routerLink" routerLinkActive="active">
                  <img class="active-img" lazy="loading" [src]="item.icon" />
                  <span>{{ item.menuItemName }}</span>
                </div>
              </a>
              <div class="menu-item" *ngIf="!isHeaderMenuReady">
                <p class="skeleton-loading skeleton-img"></p>
                <p class="skeleton-loading skeleton-text"></p>
              </div>
            </ng-container>
          } @else {
            <app-header-level2-menu></app-header-level2-menu>
          }
        </div>
        <div class="header-right" #headerRight>
          <!-- 登录的时候显示钱包 -->
          <app-currency-wallet *ngIf="logined"></app-currency-wallet>
          <app-top-bar></app-top-bar>
        </div>
      </div>
    </div>
  </div>
</div>
